export default __webpack_public_path__ + "static/media/defendant.46ddd147.png";